export default "__VITE_ASSET__7861016d__"